"use client";

import React from "react";
import { Monitor, Palette, HeartHandshake, Search, Globe, ShieldCheck } from "lucide-react";
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const services = [{
  title: "KI-gestützte SEO",
  description: "Ihre Website wird automatisch für Google optimiert. Texte, Bilder, Ladezeiten – alles abgestimmt, damit Kunden Sie finden.",
  icon: Search
}, {
  title: "Ihre Wunsch-Domain inklusive",
  description: "Registrieren Sie .ch, .com oder .de direkt bei uns. Alles an einem Ort, kein externer Anbieter nötig.",
  icon: Globe
}, {
  title: "Support, der Sie versteht",
  description: "Kein Callcenter, kein Bot. Unser Team hilft Ihnen persönlich – auf Deutsch, per Chat oder Video.",
  icon: HeartHandshake
}, {
  title: "Professionelles Design",
  description: "Über 30 branchenspezifische Vorlagen – von der Arztpraxis bis zum Restaurant. Individuell anpassbar, sofort einsatzbereit.",
  icon: Palette
}, {
  title: "Hosting auf Google Cloud",
  description: "Schnell, sicher und zuverlässig. Ihre Website läuft auf der gleichen Infrastruktur wie die grössten Unternehmen der Welt.",
  icon: Monitor
}, {
  title: "SSL & Datenschutz inklusive",
  description: "Jede Website erhält automatisch ein SSL-Zertifikat. DSGVO-konform und sicher – ohne Zusatzkosten oder Konfiguration.",
  icon: ShieldCheck
}];
export default function DigitaleLoesungenBranding() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="10692" id="alles-in-einem-funktionen" ref={ref} className={`bg-background text-foreground py-24 transition-opacity duration-700 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
      <div className="container mx-auto px-6">
        <div className="mb-16 text-center max-w-3xl mx-auto">
          <h2 className="text-3xl md:text-5xl font-bold tracking-tight mb-4 text-foreground">
            Alles, was Ihr KMU online braucht
          </h2>
          <p className="text-muted-foreground text-xl">
            Website, Hosting, SEO und Support. Kein Plugin-Chaos, keine
            versteckten Kosten.
          </p>
        </div>
 
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((service, index) => <Card key={index} data-index={index} className="h-full border border-border bg-card transition-all duration-300 hover:border-primary/50 hover:shadow-xl">
              <CardHeader className="pb-4">
                <div className="mb-4 inline-flex h-12 w-12 items-center justify-center rounded-lg border border-border bg-secondary text-primary transition-colors duration-300 hover:bg-primary hover:text-white hover:border-primary">
                  <service.icon className="h-6 w-6" strokeWidth={1.5} />
                </div>
                <CardTitle className="text-xl font-bold">
                  {service.title}
                </CardTitle>
              </CardHeader>
              <CardContent className="pb-6">
                <CardDescription className="text-base leading-relaxed text-muted-foreground">
                  {service.description}
                </CardDescription>
              </CardContent>
            </Card>)}
        </div>
      </div>
    </section>;
}